import React from 'react';
import Draggable from 'react-draggable';
import api from '../../api/axios';

const MesaDraggable = ({ mesa, onClick, recargar }) => {
  const handleStop = async (e, data) => {
    try {
      await api.put(`/tables/${mesa.id}`, {
        pos_x: data.x,
        pos_y: data.y,
      });
      recargar(); // Para refrescar posiciones si querés
    } catch (error) {
      console.error('Error al actualizar posición:', error);
    }
  };

  const style = {
    width: mesa.shape === 'circle' ? 60 : 80,
    height: 60,
    borderRadius: mesa.shape === 'circle' ? '50%' : '8px',
    backgroundColor: mesa.status === 'libre' ? '#28a745' :
                    mesa.status === 'ocupada' ? '#dc3545' :
                    mesa.status === 'en_espera' ? '#ffc107' :
                    mesa.status === 'abonada' ? '#17a2b8' :
                    '#6c757d',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'grab',
    fontWeight: 'bold',
    boxShadow: '0 0 4px rgba(0,0,0,0.4)',
    position: 'absolute',
    userSelect: 'none'
  };

  return (
    <Draggable
      bounds="parent"
      position={{ x: mesa.pos_x, y: mesa.pos_y }}
      onStop={handleStop}
    >
      <div style={style} onClick={() => onClick(mesa)}>
        {mesa.name}
      </div>
    </Draggable>
  );
};

export default MesaDraggable;
